import React, { useEffect } from "react";
import { Modal } from "antd";
import styled from "styled-components";
import "./index.scss";

export default function BaseIntro({
  backgroundImage,
  open,
  children,
  className,
  onCancel,
  getContainer = false,
  isShowFooter,
  centered = true,
  showClose = false,
  ...props
}) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = 'auto';
    }
  }, [open]);
  return (
    <StyleModal
      onCancel={onCancel}
      visible={open}
      // closable={false}
      //   backgroundImage={backgroundImage}
      getContainer={getContainer ? false : ""}
      className={className}
      footer={false}
      centered={centered}
      // closeIcon={showClose}
      {...props}
    >
      {children}
    </StyleModal>
  );
}

const StyleModal = styled(Modal)`
  /* background-image: url(${(props) => props.backgroundImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 680px;
  min-width: 480px !important; */
  max-width: 100% !important;

  .ant-modal-close {
    color: white;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 50%;
    width: 44px;
    height: 44px;
    aspect-ratio: 1 / 1;
    transform: translate(-70%, 70%);
    .ant-modal-close-x {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    svg {
      font-size: 20px;
      font-weight: bold;
    }
  }

  .ant-modal-content {
    background-color: inherit !important;
    box-shadow: none !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
    padding: 0!important;
    .popup-content {
      margin-top: 60px;

      &__title {
        display: flex;
        flex-direction: column;
        align-items: center;

        &-text {
          font-size: 18px;
          color: #fff;
          text-align: center;
          .highlight {
            font-weight: bold;
          }
          & > span {
            font-weight: 300;
          }
        }
      }

      &__body {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .prize-super {
          display: flex;
          justify-content: center;
          gap: 27px;
          margin: 44px 0 44px 0;

          & .prize-image-wrapper {
            &__bg {
              width: 264px;
              height: 264px;
            }

            img {
              width: 140px;
              height: 140px;
            }
          }
        }

        .prize-image-wrapper {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 16px 0 16px 0;
          &.no-wrapper {
            margin-top: 36px;
          }

          & > img {
            position: relative;
            z-index: 2;
          }

          &__bg {
            position: absolute;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            width: 370px;
            height: 370px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1;
          }
        }

        .prize-text-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: none;
          .prize-text-normal {
            font-size: 20px;
            font-weight: 500;
            color: #fff;
            text-align: center;
            &.top {
              font-size: 20px;
            }

            .shrikhand {
              display: block;
            }
          }
        }

        .mission-cards {
          margin-top: 16px;

          .mission-card {
            & > div {
              gap: 8px;
            }
          }
        }
      }
    }

    .shrikhand {
      font-family: "Shrikhand", serif !important;
      font-weight: 400;
      font-style: normal;
      color: #fff;
      font-size: 33px;
      -webkit-text-stroke: 2px rgba(23, 110, 229, 1);
      text-shadow: 0 4px 1px rgba(7, 110, 198, 1);
      text-align: center;

      &.medium {
        font-size: 32px;
        -webkit-text-stroke: 1.5px rgba(23, 110, 229, 1);
      }

      &.small {
        font-size: 26px;
        -webkit-text-stroke: 1px rgba(23, 110, 229, 1);
      }

      @media (max-width: 486px) {
        font-size: 36px;

        &.medium {
          font-size: 28px;
        }

        &.small {
          font-size: 24px;
        }
      }

      @media (max-width: 425px) {
        font-size: 32px;

        &.medium {
          font-size: 26px;
        }

        &.small {
          font-size: 22px;
        }
      }

      @media (max-width: 370px) {
        font-size: 28px;

        &.medium {
          font-size: 22px;
        }

        &.small {
          font-size: 18px;
        }
      }

      @media (max-width: 325px) {
        font-size: 28px;

        &.medium {
          font-size: 20px;
        }

        &.small {
          font-size: 16px;
        }
      }
    }

    .no-shadow {
      -webkit-text-stroke: 0px !important;
    }
  }
`;
